import React from "react";
import Preview from "./preview";
import Template from "./template";

export default class Decks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      templateTransition: false
    };
  }

  componentDidMount() {
    if (this.props.adding) {
      setTimeout(() => this.setState({ templateTransition: true }), 10);
    }
  }

  componentWillUnmount() {
    this.setState({ templateTransition: false });
  }

  render() {
    const { adding, cancel, isbn, decks, onClick } = this.props;
    return (
      <div id="decks-container">
        <ul
          id="decks"
          role="region"
          aria-label={i18n.t("reader.flashcards.flashcard-decks")}
        >
          {adding && (
            <li
              className={`presentation-container ${
                this.state.templateTransition || adding ? "slide" : ""
              }`}
              role="region"
              aria-label={i18n.t("reader.flashcards.adding-new-deck")}
            >
              <Template adding={adding} cancel={cancel} isbn={isbn} />
            </li>
          )}
          {decks.map(deck => (
            <li
              className={`presentation-container slide`}
              key={`deck-${deck.uuid}`}
              role="region"
              aria-label={i18n.t("reader.flashcards.name-of-deck", {
                deckName: deck.title
              })}
            >
              <Preview deck={deck} onClick={onClick} isbn={isbn} />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
